<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    isRounded: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes () {
      return {
        BaseCard: true,
        'BaseCard--rounded': this.isRounded
      }
    }
  }
}
</script>

<style lang="postcss">
.BaseCard {
  background-color: theme('colors.grey-light');
  overflow: hidden;

  .is-dark-chrome-theme & {
    @apply bg-[#464951];
  }
}

/* --- Misc modifiers --- */
.BaseCard--rounded {
  border-radius: 10px;
}

</style>
